import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { unit, UnitManipulationViewModel } from "./unitManipulation-viewModel"

export class UnitManipulationView extends View<UnitManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-8CB0F6C0-F640-4975-A8E9-42073B549B6C"
    }
    loadHtml(): string {
        let element = require('./unitManipulation.html').default;
        let style = require('./unitManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set units(v: ObservableArray<unit>) { this._units = v; } public get units(): ObservableArray<unit> { return this._units;} private _units: ObservableArray<unit>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

    addNew(){
        this.dataContext.addNew();
    }

}
